import { Pipe, PipeTransform } from '@angular/core';
import { ProductConfiguration } from '../../models/fitting-query-params.model';

@Pipe({
  name: 'showFittingFilter'
})
export class ShowFittingFilterPipe implements PipeTransform {

  transform(configurations: ProductConfiguration[], configFilter: { name: string }): boolean {
    return configurations
      .filter(f => f.availableConfiguration?.availableConfigurationFilters
        .map(f => f.name?.toLowerCase())
        .includes(configFilter.name.toLowerCase())).length > 0;
  }

}
